import { render, staticRenderFns } from "./MySelection.vue?vue&type=template&id=a5c677fa&scoped=true"
import script from "./MySelection.vue?vue&type=script&lang=js"
export * from "./MySelection.vue?vue&type=script&lang=js"
import style0 from "./MySelection.vue?vue&type=style&index=0&id=a5c677fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c677fa",
  null
  
)

export default component.exports